<template>
  <div class="container">
    <div class="section">
      <div class="box">
        <Tabs />
        <Search />
      </div>
      <Items />
    </div>
  </div>
</template>

<script>
import Tabs from "../components/menu/Tabs";
import Search from "../components/menu/Search";
import Items from "../components/items/Items";

export default {
  components: {
    Tabs,
    Search,
    Items
  }
};
</script>